import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  OnInit,
} from '@angular/core';
import { AuthService, User } from '@auth0/auth0-angular';
import { UserService } from '../../core/user.service';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';

interface user {
  name: string;
  avatar: string;
  title_job: string;
}

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent implements OnInit {
  @Input() user: user = {
    name: 'David',
    avatar: 'DK',
    title_job: 'Web Developer',
  };
  @Input() isCollapsed: boolean = false;
  @Input() chatCount: number = 5;
  @Input() notificationCount: number = 21;
  @Output() toggleCollapse = new EventEmitter<boolean>();
  @Output() goToUserProfile = new EventEmitter<void>();

  userData: User | null = null;

  constructor(private auth: AuthService, private userService: UserService, private router: Router) {}

  ngOnInit(): void {

    this.auth.user$.subscribe((user) => {
      if(user) {
        this.userData = user;
        return;
      }

      this.userData = this.userService.getAuthUserData();
    })
    this.checkScroll();
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.checkScroll();
  }

  checkScroll(): void {
    const header = document.querySelector('.header');
    if (header) {
      if (window.pageYOffset > 0) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.toggleCollapse.emit(this.isCollapsed);
  }

  onGoToUserProfile() {
    this.goToUserProfile.emit();
  }

  async onLogout() {
    const isAuth =  await firstValueFrom(this.auth.isAuthenticated$);

    localStorage.removeItem('user_data');
    localStorage.removeItem('token_data');

    this.auth.logout();

    if(!isAuth) {
      this.router.navigate(['/login']);
    }
  }
}
